const ChooseAllSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <mask id="mask0_choose_all" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>

      <g mask="url(#mask0_choose_all)">
        <path
          d="M5 2.5H13C13.2761 2.5 13.5 2.72386 13.5 3V11C13.5 11.2761 13.2761 11.5 13 11.5H5C4.72386 11.5 4.5 11.2761 4.5 11V3C4.5 2.72386 4.72386 2.5 5 2.5Z"
          stroke="#333333"
        />
        <path
          d="M3 4.5H11C11.2761 4.5 11.5 4.72386 11.5 5V13C11.5 13.2761 11.2761 13.5 11 13.5H3C2.72386 13.5 2.5 13.2761 2.5 13V5C2.5 4.72386 2.72386 4.5 3 4.5Z"
          fill="white"
          stroke="#333333"
        />
        <path d="M5 9L6.5 10.5L9 7.5" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
};

export default ChooseAllSvg;